import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPartners } from '../../../../manage-player/api/services'
import { PartnerQueryKeys } from '@/modules/manage-player/keys'
import {
	GetPartnerRequest,
	GetPartnerResponse,
} from '@/modules/manage-player/type'

export default function useQueryGetPartner(
	payload: GetPartnerRequest,
	props?: UseBaseQueryOptions<GetPartnerResponse>,
) {
	return useQuery({
		queryKey: [PartnerQueryKeys.GetPartners, payload],
		queryFn: () => getPartners(payload),
		...props,
	})
}
